/**
 * masonry
 *
 * @plugin  masonry
 * @link    http://masonry.desandro.com/
 */

+function ($) {
    'use strict';

    $('.m8s').submit(function(e){
        e.preventDefault();

        var form = $(this),
            data = {};

        $.each(form.serializeArray(), function(i,o) {
            data[o.name] = o.value;
        });

        form.find('.m8s-alert').remove();

        $.ajax({
            url: form.attr('action'),
            data: data,
            type: 'post',
            headers: {
                "Accept": "application/json"
            },
            success: function( response ) {
                var msg = $('<div class="m8s-alert alert" />');

                msg.append('<div class="m8s-alert__title">' + response.title + '</div>');
                msg.append('<div class="m8s-alert__message">' + response.message + '</div>');

                if (response.success) {
                    msg.addClass('alert--success success');
                    form.html(msg);
                } else {
                    msg.addClass('alert--error error');
                    form.prepend(msg);
                }
            }
        });
    });

}(jQuery);